// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `button.styles_addCycleButton__yp26u {
  height: 100%;
  width: 100%;
  display: flex;
  border: 1px dashed grey;
  justify-content: center;
  align-items: center;
  margin: 1rem 0rem;
  padding: 1.5rem; }
`, "",{"version":3,"sources":["webpack://./src/modules/booths/components/BoothProspectiveCycles/styles.module.scss"],"names":[],"mappings":"AAAA;EACI,YAAY;EACZ,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe,EAAA","sourcesContent":["button.addCycleButton {\n    height: 100%;\n    width: 100%;\n    display: flex;\n    border: 1px dashed grey;\n    justify-content: center;\n    align-items: center;\n    margin: 1rem 0rem;\n    padding: 1.5rem;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"addCycleButton": `styles_addCycleButton__yp26u`
};
export default ___CSS_LOADER_EXPORT___;
